import { gsap } from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

import initScrollTrigger from '../../helpers/initScrollTrigger';
import { IS_HOME_VERTICAL } from '../../helpers/consts';

gsap.registerPlugin(ScrollTrigger);

const initCardsSectionAnims = () => {
	if(IS_HOME_VERTICAL) return;

	initScrollTrigger();

	const section = document.querySelector('.js-cards-section');
	if(section) {
		const main = section.querySelector('.js-cards-section-main');
		const items = section.querySelectorAll('.js-cards-section-card');
		const text = section.querySelector('.js-cards-section-text');
		const brief = section.querySelector('.js-cards-section-brief');

		let tl = null;

		tl = new gsap.timeline({
			paused: true,
		});

		tl.from(items[0], {
			x: '100%',
			rotation: 10,
			duration: 1,
		});
		tl.from(items[1], {
			rotation: -10,
			duration: 1,
		}, 0);
		tl.from(items[2], {
			x: '-100%',
			rotation: 10,
			duration: 1,
		}, 0);

		tl.from(text, {
			opacity: 0,
			duration: 0.5,
		}, 0.5);

		tl.from(brief, {
			opacity: 0,
			duration: 0.5,
		}, 0.5);


		tl.call(() => section.classList.toggle('is-hover-enabled'), null, 0.5);

		tl.to(section, {
			duration: 1.5,
		}, 1);
		tl.call(() => section.classList.toggle('is-hover-enabled'), null, 2);

		tl.to(text, {
			opacity: 0,
			duration: 1,
		}, 2);


		tl.to(brief, {
			opacity: 0,
			duration: 1,
		}, 2);

		tl.to(items[0], {
			x: '100%',
			rotation: 10,
			duration: 1,
		}, 2);
		tl.to(items[1], {
			rotation: -10,
			duration: 1,
		}, 2);
		tl.to(items[2], {
			x: '-100%',
			rotation: 10,
			duration: 1,
		}, 2);

		const setFixedState = (self) => {
			const progress = self.progress;
			const distance = section.offsetWidth - main.offsetWidth;
			gsap.set(main, {x: distance * progress});
		};

		ScrollTrigger.create({
			trigger: section,
			// animation: tl,
			horizontal: true,
			start: () => 'left left',
			end: () => 'right right',
			onUpdate: setFixedState,
		});



		const setAnimState = (self) => {
			tl.progress(self.progress);
		};

		ScrollTrigger.create({
			trigger: section,
			// animation: tl,
			horizontal: true,
			start: () => 'left 30%',
			end: () => 'right 30%',
			onUpdate: setAnimState,
		});
	}
};

export default initCardsSectionAnims;
